import { render, staticRenderFns } from "./createNotice.vue?vue&type=template&id=1e96a31a&scoped=true"
import script from "./createNotice.vue?vue&type=script&lang=js"
export * from "./createNotice.vue?vue&type=script&lang=js"
import style0 from "./createNotice.vue?vue&type=style&index=0&id=1e96a31a&prod&lang=css"
import style1 from "./createNotice.vue?vue&type=style&index=1&id=1e96a31a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e96a31a",
  null
  
)

export default component.exports